import { AuthorizationParams, useAuth0 } from '@auth0/auth0-react';
import { useStableFunction } from '../../../core/hooks/use-stable-function';
import { AUTH0_AUDIENCE, AUTH0_SCOPE } from '../../../core/config';

/**
 * Do not use this hook directly. Auth Guard is the place where it should be set up.
 */
export const useAccessTokenRetriever = () => {
  const { loginWithRedirect, getAccessTokenSilently } = useAuth0();

  const retrieveAccessToken = useStableFunction(async () => {
    const authorizationParams: AuthorizationParams = {
      audience: AUTH0_AUDIENCE,
      scope: AUTH0_SCOPE,
    };

    try {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: authorizationParams,
      });

      return accessToken;
    } catch (e) {
      await loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
      throw e;
    }
  });

  return retrieveAccessToken;
};
